import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-beneficiaries-empty-box',
  templateUrl: './beneficiaries-empty-box.component.html',
  styleUrls: ['./beneficiaries-empty-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BeneficiariesEmptyBoxComponent {
  @Input() message =
    'Na falta de indicação da pessoa ou beneficiário, ou se por qualquer motivo não prevalecer a que for feita, o capital segurado será pago conforme Art. 792 do Código Civil Brasileiro';
}
